// Updated to use shared API instance and injectApi/enhanceApi pattern
import { api } from '../middleware/api';

// Define endpoints using injectApi pattern
export const steindentApi = api
  .enhanceEndpoints({ addTagTypes: ['Indent'] })
  .injectEndpoints({
    endpoints: builder => ({
      getIndents: builder.query<st_eindent[], string>({
        query: cid => `steindent/${cid}`,
        providesTags: ['Indent']
      }),
      getIndentsByPending: builder.query<st_eindent[], number>({
        query: id => `steindent/bypending/${id}`,
        providesTags: ['Indent']
      }),
      getIndent: builder.query<st_eindent, string>({
        query: id => `steindent/byid/${id}`
      }),
      insertIndent: builder.mutation({
        query: gate => ({
          url: `steindent/`,
          method: 'POST',
          body: gate
        }),
        invalidatesTags: ['Indent']
      }),
      updateIndent: builder.mutation({
        query: gate => ({
          url: `steindent/`,
          method: 'PUT',
          body: gate
        }),
        invalidatesTags: ['Indent']
      }),
      deleteIndent: builder.mutation({
        query: Indent => ({
          url: `steindent/${Indent.it_id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['Indent']
      })
    }),
    overrideExisting: false
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetIndentsQuery,
  useGetIndentsByPendingQuery,
  useGetIndentQuery,
  useInsertIndentMutation,
  useUpdateIndentMutation,
  useDeleteIndentMutation
} = steindentApi;

